module.exports = __webpack_public_path__ + "static/media/calendar.d89c54c6.svg";